
/**
 * v-copy 复制内容
 */
let str = ref('');
const handleData = ()=>{
    const input = document.createElement("input");
    input.value = str.value.toLocaleString();
    document.body.appendChild(input);
    input.select();
    document.execCommand("Copy");
    document.body.removeChild(input);
    ElMessage({ type: "success", message: "复制成功" });
}

const checkCopy = (el, binding) => {
    str.value = binding.value;
    el.addEventListener("click", handleData);
}

export default {
    mounted(el, binding) {
        checkCopy(el, binding)
    },
    updated(el, binding) {
        str.value = binding.value;
    },
    beforeUnmount(el) {
        el.removeEventListener("click", handleData);
    }
};